/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Stage_CancelledInputs */

const vi_carrier_stage_cancelled = /** @type {(inputs: Carrier_Stage_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã huỷ vận đơn`)
};

/**

* @param {Carrier_Stage_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_stage_cancelled = /** @type {((inputs?: Carrier_Stage_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Stage_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_stage_cancelled(inputs)
});